import React from 'react';
import Image, { StaticImageData } from 'next/image';
import ParrotCheer from '@/assets/characters/parrots/parrot_cheer.png';
import ParrotExplorer from '@/assets/characters/parrots/parrot_explorer.png';
import ParrotPoint from '@/assets/characters/parrots/parrot_point.png';
import ParrotReader from '@/assets/characters/parrots/parrot_reader.png';
import ParrotScientist from '@/assets/characters/parrots/parrot_scientist.png';
import ParrotSide from '@/assets/characters/parrots/parrot_side.png';
import ParrotStand from '@/assets/characters/parrots/parrot_stand.png';
import ParrotTalk from '@/assets/characters/parrots/parrot_talk.png';
import ParrotTeacher from '@/assets/characters/parrots/parrot_teacher.png';
import ParrotTrophy from '@/assets/characters/parrots/parrot_trophy.png';
import ParrotWelcome from '@/assets/characters/parrots/parrot_welcome.png';

/**
 * Character — "Pip", the Pickatale adventurer-parrot mascot. Renders one of the
 * eleven official transparent clay poses, with an optional idle "bob" animation
 * and the mascot drop shadow. Use as-is — never recolour or redraw.
 */
export type ParrotPose =
  | 'welcome'
  | 'talk'
  | 'stand'
  | 'side'
  | 'point'
  | 'reader'
  | 'scientist'
  | 'teacher'
  | 'explorer'
  | 'cheer'
  | 'trophy';

const POSES: Record<ParrotPose, StaticImageData> = {
  welcome: ParrotWelcome,
  talk: ParrotTalk,
  stand: ParrotStand,
  side: ParrotSide,
  point: ParrotPoint,
  reader: ParrotReader,
  scientist: ParrotScientist,
  teacher: ParrotTeacher,
  explorer: ParrotExplorer,
  cheer: ParrotCheer,
  trophy: ParrotTrophy,
};

interface CharacterProps {
  pose?: ParrotPose;
  width?: string;
  animate?: 'idle' | 'none';
  alt?: string;
  className?: string;
}

export const Character = ({
  pose = 'welcome',
  width = 'clamp(180px, 20vw, 360px)',
  animate = 'idle',
  alt = 'Pip the Pickatale parrot',
  className,
}: CharacterProps) => (
  <span
    className={className}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width,
    }}
  >
    <Image
      src={POSES[pose]}
      alt={alt}
      style={{
        width: '100%',
        height: 'auto',
        filter: 'var(--shadow-character)',
        animation:
          animate === 'idle' ? 'lp-bob 4s ease-in-out infinite' : 'none',
        transformOrigin: 'bottom center',
      }}
    />
  </span>
);
